export const appConstants = {
  windowBreakpoints: {
    mobile: 768,
    tablet: 1008,
    desktop: 1140,
    wideScreen: 1284,
    fullHD: 1440
  },
  incentives: {
    OECDmedianIdXBTI: 'XBTI_OECD1',
    EUmedianIdXBTI: 'XBTI_EU1',
    OECDmedianIdIBTI: 'IBTI_OECD1',
    EUmedianIdIBTI: 'IBTI_EU1'
  },
  cyprusNote:
    'Note by Türkiye: The information in the documents with reference to "Cyprus" relates to the southern part of the Island. There is no single authority representing both Turkish and Greek Cypriot people on the Island. Türkiye recognizes the Turkish Republic of Northern Cyprus (TRNC). Until a lasting and equitable solution is found within the context of the United Nations, Türkiye shall preserve its position concerning the "Cyprus issue". Note by all the European Union Member States of the OECD and the European Union: The Republic of Cyprus is recognised by all members of the United Nations with the exception of Türkiye. The information in the documents relates to the area under the effective control of the Government of the Republic of Cyprus.'
}
